import { GridRowCount, GridSlotsComponentsProps } from "@mui/x-data-grid";
import { FunctionComponent, createElement } from "react";

export function CommonTableFooter(
    props: NonNullable<GridSlotsComponentsProps["footer"]> & {
        startElement?: FunctionComponent;
        startProps?: Record<string, unknown>;
        rows?: Record<string, unknown>[];
        allRows?: Record<string, unknown>[];
    }
) {
    return (
        <div className="flex py-1 px-2 font-medium border-t bg-white justify-between ">
            {(props.startElement &&
                createElement(props.startElement || "div", { allRows: props.allRows || [] } as Record<
                    string,
                    unknown
                >)) || <span className=" h-8"></span>}

            <GridRowCount rowCount={props.allRows?.length || 0} visibleRowCount={props.rows?.length || 0} />
        </div>
    );
}
